<template lang="pug">
	.nav-content(
		@mouseover="resetCurrent"
		@mouseout="resetCurrent"
	)
		ul
			template(v-for="entry, index in menu")
				navigation-link(
					exact
					:index="(index+1)"
					:selected="current"
					:sub-selected="subcurrent"
					:active-area="routeArea === entry.route"
					:label="entry.label"
					:has-children="Boolean(entry.children && entry.children.length)"
					:to="entry.url"
					@close="clickSelection"
				)
					ul(v-if="entry.children && entry.children.length")
						navigation-link(
							v-for="subentry, subindex in entry.children"
							:key="subentry.url"
							exact
							:label="subentry.label"
							:index="(index+1) + '.' + (subindex+1)"
							:subindex="(subindex+1)"
							:has-children="false"
							:selected="(index+1) === current ? subcurrent : 0"
							:active-area="routeArea === subentry.route"
							:to="subentry.url"
							@close="clickSelection"
						)
</template>

<script>
import NavigationLink from '@/components/NavigationLink'
export default {
	name      : 'Navigation',
	components: {
		NavigationLink
	},
	props: {
		active   : Boolean,
		routeArea: String
	},
	data () {
		return {
			menu: [
				{
					url  : '/',
					label: 'Home'
				},
				{
					url     : '/about-the-hukos',
					label   : 'About the Hukos',
					route   : 'about-the-hukos',
					children: [
						{
							url  : '/about-the-hukos/appearance',
							label: 'Appearance'
						},
						{
							url  : '/about-the-hukos/magic',
							label: 'Magic'
						},
						{
							url  : '/about-the-hukos/life-cycle',
							label: 'Life Cycle'
						},
						{
							url  : '/about-the-hukos/family',
							label: 'Family'
						},
						{
							url  : '/about-the-hukos/religion',
							label: 'Religion'
						},
						{
							url  : '/about-the-hukos/evolution',
							label: 'Evolution'
						}
					]
				},
				{
					url     : '/about-theha',
					label   : 'About the World',
					route   : 'about-theha',
					children: [
						{
							url  : '/about-theha/lafo-river',
							label: 'Lafo River'
						}
					]
				},
				{
					url  : '/author',
					label: 'Author Notes'
				},
				{
					url  : '/legal-credits',
					label: 'Legal & Credits'
				}
			],
			current   : 0,
			subcurrent: 0
		}
	},
	methods: {
		resetCurrent () {
			this.current = 0
			this.subcurrent = 0
		},
		increment () {
			if (this.subcurrent > 0) {
				this.subcurrent++
				if (this.subcurrent > this.menu[this.current - 1].children.length) this.subcurrent = 1
				return
			}

			if (this.current === 0) this.current = 1
			else {
				this.current++
				if (this.current > this.menu.length) this.current = 1
			}
		},
		decrement () {
			if (this.subcurrent > 0) {
				this.subcurrent--
				if (this.subcurrent < 1) this.subcurrent = this.menu[this.current - 1].children.length
				return
			}

			if (this.current === 0) this.current = 1
			else {
				this.current--
				if (this.current < 1) this.current = this.menu.length
			}
		},
		enterSub () {
			if (this.current > 0 && this.subcurrent === 0) {
				const currentEntry = this.menu[this.current - 1]
				if (currentEntry.children) {
					this.subcurrent = 1
				}
			}
		},
		exitSub () {
			if (this.current > 0 && this.subcurrent > 0) {
				this.subcurrent = 0
			}
		},
		submitSelection () {
			if (this.current > 0) {
				const currentEntry = this.menu[this.current - 1]
				if (this.subcurrent > 0) {
					const subEntry = currentEntry.children[this.subcurrent - 1]
					if (subEntry && this.$route.path !== subEntry.url) {
						this.$router.push(subEntry.url)
					}
				} else if (currentEntry && this.$route.path !== currentEntry.url) {
					this.$router.push(currentEntry.url)
				}
				setTimeout(() => { this.$emit('close') }, 100)
			}
		},
		clickSelection () {
			setTimeout(() => { this.$emit('close') }, 50)
		}
	},
	watch: {
		active () {
			this.resetCurrent()
		}
	}
}
</script>
